import { CloseIcon, EditIcon, ShareIcon } from "../../Assets/assets";
import Modal from "../Modal/Modal";
import "./PreviewBar.css";
export default function PreviewBar(props) {
  const shimmerStyle =
    getComputedStyle(document.documentElement).getPropertyValue(
      "--primaryColor"
    ) === "#0E0E0E"
      ? "shimmer-dark"
      : "shimmer-light";

  return (
    <div
      style={{
        minWidth: "360px",
        width: "488px"
      }}
    >
      <Modal
        show={true}
        canIgnore={true}
        RemoveBlackOverlay={true}
        onClose={() => {
          props.navigate(-1);
        }}
        height="inherit-parent-height"
        width="width-488px"
        minWidth="none"
        borderRadius="none"
        background="background-color-tertiaryColor2"
        position="position-absolute bottom-0 right-0"
        modalBodyClassName="display-flex flex-direction-column"
      >
        <div
          data-cy="CLOSE-PREVIEW-BAR"
          style={{ flexShrink: 0 }}
          className="display-flex flex-justify-content-space-between  padding-larger"
        >
          <div>
            {props.loading ? (
              <div className="">
                <div
                  className={shimmerStyle}
                  style={{ height: "24px", width: "200px" }}
                />
                <div
                  className={`${shimmerStyle} margin-top-small`}
                  style={{ height: "16px", width: "100px" }}
                />
              </div>
            ) : (
              <>
                <div className="font-color-tertiaryColor">{props.title}</div>
                {props.description ? (
                  <div className="font-size-small padding-top-small font-color-tertiaryColor6">
                    {props.description}
                  </div>
                ) : null}
              </>
            )}
          </div>

          <div className=" display-flex flex-justify-content-center padding-top-default ">
            {typeof props.onShareClick === "function" ? (
              <div
                onClick={() => {
                  props.onShareClick();
                }}
                data-cy="SHARE-ICON"
                style={{
                  height: "16px",
                  width: "16px"
                }}
                className="cursor-pointer margin-right-larger"
              >
                <ShareIcon color="var(--tertiaryColor6)" />
              </div>
            ) : (
              <></>
            )}

            {typeof props.editOnClick === "function" ? (
              <div
                onClick={() => {
                  props.editOnClick();
                }}
                data-cy="EDIT-ICON"
                style={{
                  height: "20px",
                  width: "20px"
                }}
                className="cursor-pointer margin-right-large"
              >
                <EditIcon
                  height="20"
                  width="20"
                  color="var(--tertiaryColor6)"
                />
                {props.showNotify ? (
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      backgroundColor: "var(--secondaryColor)",
                      borderRadius: "50%",
                      position: "relative",
                      left: "12px",
                      bottom: "10px"
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <></>
            )}

            {props.onCloseClick ? (
              <div
                onClick={() => {
                  props.onCloseClick();
                }}
                data-cy="CLOSE-ICON"
                style={{
                  height: "16px",
                  width: "16px"
                }}
                className="cursor-pointer"
              >
                <CloseIcon color="var(--tertiaryColor6)" />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div
          style={{ minHeight: 0 }}
          className={`flex-grow-1 ${
            props.removeMargin ? "" : "margin-larger"
          } overflow-scroll`}
          data-cy="PREVIEW-BAR-BODY"
        >
          {props.loading ? (
            <div
              className="display-flex flex-direction-column"
              style={{ gap: "16px" }}
            >
              {[...Array(4)].map((_, index) => (
                <div
                  key={index}
                  className={shimmerStyle}
                  style={{ height: "30px", width: "500px" }}
                />
              ))}
            </div>
          ) : (
            props.children || <div />
          )}
        </div>
      </Modal>
    </div>
  );
}
